export default __webpack_public_path__ + "static/media/slide-3.2e4d573a.jpg";